import { createBrowserHistory } from 'history';

export const history = createBrowserHistory({
  basename: 'vi-frontend-recruiter',
});
